module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/esophagus-a66dc0955925f19bb30bc755a3a8f323.png";